import React, { useEffect, useState } from 'react';
import { useApi } from '../../api';
import { FaUser } from 'react-icons/fa';
import { Autocomplete, Grid, TextField } from '@mui/material';

const ClienteDatos = ({ form, setForm }) => {
  const [clientes, setClientes] = useState([]);
  const api = useApi();

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await api.get(`${process.env.REACT_APP_API_URL}/api/clientes/`);
        setClientes(res.data);
      } catch (err) {
        console.error('Error cargando clientes:', err);
      }
    };

    fetchClientes();
  }, []);

  const handleSelection = (selected) => {
    if (selected.length > 0) {
      const cliente = selected[0];
      setForm(prev => ({
        ...prev,
        cliente: cliente.nombre,
        cliente_id: cliente.id,
        direccion: cliente.direccion,
        telefono: cliente.telefono,
        email: cliente.correo
      }));
    } else {
      setForm(prev => ({
        ...prev,
        cliente: '',
        cliente_id: '',
        direccion: '',
        telefono: '',
        email: ''
      }));
    }
  };

  return (
    <div className="card card-app mb-4">
      <div className="card-header-app"><FaUser /> DATOS DEL CLIENTE</div>
      <div className="card-body">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Autocomplete
              id="cliente"
              options={clientes}
              getOptionLabel={(option) => option?.nombre || ''}
              value={clientes.find(c => c.nombre === form.cliente) || null}
              onChange={(e, newValue) => handleSelection(newValue ? [newValue] : [])}
              renderInput={(params) => (
                <TextField {...params} label="Cliente" placeholder="Buscar cliente por nombre..." />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Dirección"
              name="direccion"
              value={form.direccion}
              disabled
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Teléfono"
              name="telefono"
              value={form.telefono}
              disabled
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Email"
              name="email"
              type="email"
              value={form.email}
              disabled
              fullWidth
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ClienteDatos;
